// {{compare unicorns ponies operator="<"}}
//   I knew it, unicorns are just low-quality ponies!
// {{/compare}}
//
// (defaults to == if operator omitted)
//
// {{equal unicorns ponies }}
//   That's amazing, unicorns are actually undercover ponies
// {{/equal}}
// (from http://doginthehat.com.au/2012/02/comparison-block-helper-for-handlebars-templates/)

Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
  if (arguments.length < 3)
    throw new Error("Handlebars Helper 'compare' needs 2 parameters")

  var operator = options.hash.operator || '=='

  var operators = {
    '==': function (l, r) {
      return l == r
    },
    '===': function (l, r) {
      return l === r
    },
    '!=': function (l, r) {
      return l != r
    },
    '<': function (l, r) {
      return l < r
    },
    '>': function (l, r) {
      return l > r
    },
    '<=': function (l, r) {
      return l <= r
    },
    '>=': function (l, r) {
      return l >= r
    },
    typeof: function (l, r) {
      return typeof l == r
    },
  }

  if (!operators[operator])
    throw new Error(
      "Handlebars Helper 'compare' doesn't know the operator " + operator
    )

  var result = operators[operator](lvalue, rvalue)

  if (result) {
    return options.fn(this)
  } else {
    return options.inverse(this)
  }
})

// {{#each_with_index records}}
//   <li class="legend_item{{index}}"><span></span>{{Name}}</li>
// {{/each_with_index}}

Handlebars.registerHelper('each_with_index', function (array, options) {
  var buffer = ''

  if ('undefined' === typeof array) {
    array = []
  }

  for (var i = 0, j = array.length; i < j; i++) {
    var item = array[i]

    // stick an index property onto the item, starting with 1, may make configurable later
    item.index = i + 1
    item.total_length = array.length

    // show the inside of the block
    buffer += options.fn(item)
  }

  // return the finished buffer
  return buffer
})

Handlebars.registerHelper('assign', function () {
  var args = [],
    len = arguments.length,
    name = arguments[0],
    result = ''

  // start at `1` to skip `name`
  for (var i = 1; i <= len; i++) {
    if (typeof arguments[i] === 'string' || typeof arguments[i] === 'number') {
      args[args.length] = arguments[i]
    }
  }
  result = args.join('')

  // inject `result` into context object, for use as option to another helper
  this[name] = result

  var fn = function () {
    return new Handlebars.SafeString(result)
  }
  Handlebars.registerHelper(name, fn)

  return ''
})

Handlebars.registerHelper('capitalize', function (word) {
  var result = word ? word.charAt(0).toUpperCase() + word.slice(1) : ''
  return new Handlebars.SafeString(result)
})

Handlebars.registerHelper('lowercase', function (str) {
  if (!str) return ''
  if (typeof str !== 'string') return ''

  return str.toLocaleLowerCase()
})

Handlebars.registerHelper('pluralize', function (num, word) {
  if (num === 1) {
    return new Handlebars.SafeString(
      "<span class='count'>" +
        num +
        "</span> <span class='label'>" +
        word +
        '</span>'
    )
  }

  var result = "<span class='count'>" + num + "</span> <span class='label'>"

  if (word === 'person') {
    result += 'people'
  } else {
    result += word + 's'
  }

  result += '</span>'

  return new Handlebars.SafeString(result)
})

Handlebars.registerHelper('_pluralize', function (str, count, includeNumber) {
  return new Handlebars.SafeString(_.pluralize(str, count, includeNumber))
})

Handlebars.registerHelper('pluralize_label', function (num, label) {
  if (num === 1) {
    return new Handlebars.SafeString(label)
  }

  var result

  if (label === 'person') {
    result = 'people'
  } else if (label === 'Person') {
    result = 'People'
  } else if (label === 'story') {
    result = 'stories'
  } else if (label === 'Story') {
    result = 'Stories'
  } else {
    result = label + 's'
  }

  return new Handlebars.SafeString(result)
})

Handlebars.registerHelper('titleize', function (words) {
  words = words ? words.split('_') : ['']
  var result = []
  _.each(words, function (word) {
    result.push(word.charAt(0).toUpperCase() + word.slice(1))
  })
  result = result.join(' ')
  return new Handlebars.SafeString(result)
})

Handlebars.registerHelper('inArray', function (array, value, options) {
  var array_check = false
  if (options.hash && options.hash.check_id) {
    if (array) {
      array_check = false
      jQuery.map(array, function (item) {
        if (item == value.toString()) {
          array_check = true
        }
      })
    } else {
      array_check = false
    }
  } else {
    array_check = array.indexOf(value) >= 0
  }

  if (array_check) {
    return options.fn(this)
  } else {
    return options.inverse(this)
  }
})

Handlebars.registerHelper('array_to_list', function (array, options) {
  var defaults = { join: ', ', finalJoin: ' and ' }
  var arr = null
  var last = null
  var settings = null

  if (array.length == 1) {
    return new Handlebars.SafeString(array[0])
  } else {
    settings = _.extend({}, defaults, options.hash)
    arr = array.slice(0)
    last = arr.pop()
    if (arr.length > 1) {
      return new Handlebars.SafeString(
        arr.join(settings.join) + settings.finalJoin + last
      )
    } else {
      return new Handlebars.SafeString(arr + settings.finalJoin + last)
    }
  }
})

Handlebars.registerHelper('nl2br', function (text) {
  var nl2br = humanize.nl2br(text)
  return new Handlebars.SafeString(nl2br)
})

// `{{or foo bar}}`, `{{#if (or foo bar)}}`
Handlebars.registerHelper('or', function (value1, value2) {
  return !!(value1 || value2)
})
